export default {
  message: {
    "error": "حدث خطأ!",
    "Sorrysomeerrorsoccurred": "عذراً، حدثت بعض الأخطاء",
    "quit": "الخروج",
    "language": "اللغة",
    "Youcanchangethelanguagehere": "يمكنك تغيير اللغة هنا!",
    "current": "الحالية",
    "home": "الرئيسية",
    "friends": "الأصدقاء",
    "wallet": "المحفظة",
    "aboutus": "معلومات عنا",
    "Sharewithfriends": "شارك مع الأصدقاء",
    "copyFailure": "فشل النسخ",
    "copySuccess": "نجاح النسخ",
    "Claimreward": "استلام المكافأة",
    "DailyLogin": "تسجيل الدخول اليومي",
    "noInvitationsYet": "لا توجد دعوات بعد",
    "LoadMore": "تحميل المزيد",
    "WatchAD": "شاهد الإعلان",
    "continue": "استمرار",
    "Congratulations": "مبروك",
    "MyFriends": "أصدقائي",
    "Invitefriends": "دعوة الأصدقاء",
    "Invitepremiumfriends": "دعوة الأصدقاء المميزين",
    "DailyTasks": "المهام اليومية",
    "inviteDesc": "+{num} ${name} مقابل كل صديق تدعوه",
    "DailyTasksDesc": "أكمل المهام للحصول على المزيد من ${name}",
    "SponsorsandPartners": "الرعاة والشركاء",
    "Receivingwallet": "محفظة الاستلام",
    "Enterwalletaddress": "أدخل عنوان محفظة {name}",
    "Claim": "استلام",
    "Booster": "معزز",
    "RentPeriod": "مدة الإيجار",
    "days30": "30 يوماً",
    "days": "يوم",
    "Dailyprofit": "الربح اليومي",
    "Totalprofit": "إجمالي الربح",
    "Quantity": "الكمية",
    "RentPrice": "سعر الإيجار",
    "RentMiner": "استئجار المنجم",
    "Insufficient": "غير كافي ${name}",
    "InsufficientMsg": "{num} ${name1} مطلوب، ادعُ أصدقاءك أو أكمل المهام لكسب المزيد من ${name2}.",
    "Settings": "الإعدادات",
    "copyid": "نسخ المعرف",
    "UpgradeSuccessfully": "ترقية ناجحة",
    "Name": "الاسم",
    "userinfo": "معلومات المستخدم",
    "disconnect": "فصل الاتصال",
    "Startmining": "بدء التعدين",
    "Welcome": "مرحباً بكم في {name}",
    "Withdrawal": "سحب الأموال",
    "Minimumamount": "المبلغ الأدنى",
    "Networkfee": "رسوم الشبكة",
    "Enteramount": "أدخل المبلغ",
    "Submit": "تقديم",
    "MinimumTip": "المبلغ المطلوب سحبه صغير جدًا. الحد الأدنى لمبلغ السحب: {num}",
    "MaximumTip": "المبلغ غير كاف، الحد الأقصى للمبلغ الذي يمكنك سحبه هو: {num}",
    "SubmittedTip": "تم التقديم، من المتوقع معالجته خلال 30-60 يوم عمل",
    "WithdrawStatus": "الحالة",
    "Submissiontime": "وقت التقديم",
    "WithdrawAwaitTip": "* يُقدر أن يستغرق الأمر 30-60 يوم عمل. دعوة المزيد من الأصدقاء يمكن أن تسرع عملية المراجعة.",
    "Processing": "يتم المعالجة",
    "Amount": "المبلغ",
    "Numberoffriends": "عدد الأصدقاء: {now}/{limit}",
    "InviteTip": "لكي تقوم بسحبك الأول، تحتاج إلى دعوة {limit} أصدقاء للانضمام إلى تطبيق التعدين.",
    "openonphone": "افتح هذا الرابط على هاتفك.",
    "claimTip": "المبلغ الذي سيتم جمعه صغير جدًا. الحد الأدنى للمبلغ الذي يمكن جمعه هو: {num}",
    "WalletBalance": "رصيد المحفظة",
    "Withdraw": "سحب",
    "SetWalletAddress": "تعيين عنوان المحفظة",
    "WithdrawalRecord": "سجل السحب",
    "Norecords": "لا توجد سجلات",
    "Whatis": "ما هو {name}؟",
    "All": "الكل",
    "save": "حفظ",
    "successWithdrawal": "تم استلام السحب {num}",
    "secondsago": "منذ {time} ثوانٍ",
    "Loading": "جاري التحميل...",
    "PaymentConfirming": "جارٍ التحقق من حالة المعاملة...",
    "Check": "تحقق",
    "CheckFail": "لم تكتمل المعاملة. يرجى التحقق مرة أخرى بعد 5 ثوانٍ.",
    "Addname": "أضف '{name}' إلى اسمك",
    "Restattcheck": "أعد تشغيل التطبيق للتحقق",
    "Copyname": "نسخ '{name}'",
    "SubmissionFailed": "فشل التقديم، يرجى المحاولة مرة أخرى لاحقًا",
    "WithdrawalReview": "مراجعة السحب",
    "WebWithdrawAwaitTip": "* يُقدر أن يستغرق الأمر 24-48 ساعة. دعوة المزيد من الأصدقاء يمكن أن تسرع عملية المراجعة.",
    "Success": "نجاح",
    "Rejection": "رفض",
    "WebSubmittedTip": "تم التقديم، من المتوقع معالجته خلال 24-48 ساعة",
    "shop": "متجر",
    "topurchase": "انتقل إلى المتجر للشراء",
    "shopDesc": "توفر محدود - احصل على خاصتك قبل أن تختفي!",
    "claim": "جمع",
    "payment_success": "تم الدفع بنجاح",
    "payment_failed": "فشل الدفع",
    "payment_cancelled": "تم إلغاء الدفع",
    "opening_payment": "جارٍ فتح عملية الدفع...",
    "payment_status": "حالة الدفع",
    "create_order_failed": "فشل إنشاء الطلب",
    "creating_ton_order": "جارٍ إنشاء طلب TON...",
    "next_step": "الخطوة التالية",
    "use_ton_payment": "استخدم دفع TON",
    "start_transaction": "ابدأ المعاملة",
    "connect_wallet": "اتصل بمحفظة",
    "address": "العنوان",
    "amount_ton": "المبلغ TON",
    "copy": "نسخ",
    "amount": "المبلغ",
    "wallet_address": "عنوان المحفظة",
    "comment_memo": "تعليق ملاحظة",
    "you_can_choose_to_connect_wallet_to_pay": "يمكنك اختيار الاتصال بالمحفظة للدفع",
    "or_manually_transfer_to_the_above_address": "أو نقل يدوي إلى العنوان أعلاه (يرجى ملاحظة أن المبلغ والملاحظة يجب أن تكون بالضبط نفس الشيء)",
    "transaction_success": "نجاح المعاملة",
    "transaction_failed": "فشل المعاملة",
    "transaction_error": "خطأ في المعاملة",
    "transaction_status": "حالة المعاملة",
    "transaction_id": "معرف المعاملة",
    "transaction_amount": "مبلغ المعاملة",
    "transaction_status_desc": "وصف حالة المعاملة",
    "payment_status_tip": "يرجى الانتظار حتى يتم تأكيد الدفع",
    "select_payment_method": "اختر طريقة الدفع",
    "total_amount": "إجمالي المبلغ",
    "creating_order": "جاري إنشاء الطلب...",
    "order_created": "تم إنشاء الطلب",
    "order_status": "حالة الطلب",
    "Applyforwithdrawal": "تقديم طلب سحب",
    "Withdrawalunlock": "فتح السحب",
    "WithdrawalunlockTip": "تحتاج إلى {num} أصدقاء مدعوين لإكمال المهام/ربط المحافظ لإلغاء قفل السحب",
    "Close": "إغلاق",
    "Delivering": "جارٍ التسليم",
    "Duetothelargenumber": "بسبب العدد الكبير من المستلمين، من المتوقع أن تصل عملية الإسقاط الجوي الخاصة بك خلال 15-20 يوم عمل",
    "select_network": "اختر الشبكة",
    "confirm": "تأكيد",
    "switching_network": "جارٍ تغيير الشبكة...",
    "network_switched": "تم تغيير الشبكة",
    "use_usdt_payment": "استخدم دفع USDT",
    "or_manually_transfer_to_the_above_address_usdt": "قم بتحويل المبلغ يدويًا إلى العنوان أعلاه (يرجى ملاحظة أن المبلغ والعنوان يجب أن يكونا متطابقين تمامًا)",
    "chain_type": "الشبكة",
    "check_transaction_status": "تحقق من حالة المعاملة",
    "transaction_wait": "المعاملة قيد المعالجة. يمكنك الخروج من التطبيق. ستصلك رسالة عند الانتهاء.",
    "twa_pay_tip_with_memo": "يرجى التأكد من أن العنوان، المبلغ، والمذكرة متوافقة لإجراء التحويل.",
    "twa_pay_tip": "يرجى التأكد من أن العنوان والمبلغ صحيحان لإجراء التحويل.",
    "creating_usdt_order": "إنشاء طلب USDT...",
    "affiliate_programs": "برامج الشراكة",
    "affiliate_programs_description": "ادعُ الأصدقاء للانضمام إلى تطبيق التعدين واكسب المكافآت.",
    "commission_details": "تفاصيل العمولة",
    "no_commission_records": "لا توجد سجلات عمولة",
    "commission_list": "قائمة العمولة",
    "input_amount": "أدخل المبلغ",
    "max": "الحد الأقصى",
    "commission_input_amount": "أدخل مبلغ العمولة",
    "min_commission": "أقل مبلغ للسحب هو {num}",
    "WithdrawalSuccess": "تم السحب بنجاح",
    "WithdrawalFailed": "فشل السحب",
    "WithdrawalProcessing": "جاري معالجة السحب",
    "award": "جائزة",
    "level": "مستوى",
    "Share_to_group": "شارك في المجموعة",
    "Exchange": "تبادل",
    "balance_not_enough": "الرصيد غير كافٍ، يمكنك فقط تبادل {num} {coin}",
    "exchange_fail": "فشل التبادل",
    "exchange_success": "تم التبادل بنجاح",
    "you_will_receive": "سوف تتلقى",
    "ShareToGroups": "مشاركة في المجموعات",
    "Numberofgroups": "عدد المجموعات: {now}/{limit}",
    "Confirm": "تأكيد",
    "ShareToGroupsDesc": "شارك في المجموعات للحصول على المزيد من {name}",
    "TokenAddress": "يرجى إدخال تفاصيل السحب مثل معرف الصرف أو عنوان USDT",
    "CashAddress": "يرجى إدخال تفاصيل السحب مثل رقم بطاقة البنك أو عنوان USDT",
    "Cancel": "إلغاء",
    "min_withdrawal_amount": "أقل مبلغ للسحب هو {num} {coin}",
    "max_withdrawal_amount": "أقصى مبلغ للسحب هو {num} {coin}",
    "withdrawal_failed": "فشل السحب",
    "withdrawal_success": "تم السحب بنجاح",
    "PayNow": "ادفع الآن",
    "PaySkip": "ادفع {num} لفتح السحب على الفور",
    "NumberofGroups": "عدد المجموعات: {now}/{limit}",
    "SendMessage": "إرسال رسالة",
    "NumberofShares": "عدد المشاركات: {now}/{limit}",
    "NumberofTasks": "عدد المهام: {now}/{limit}",
    "CompleteTask": "أكمل المهمة",
    "PleaseEnterValidAmount": "يرجى إدخال مبلغ صالح",
    "PleaseEnterValidEmail": "يرجى إدخال بريد إلكتروني صالح",
    "Feedback": "تعليق",
    "Inputfeedbackcontent": "أدخل محتوى التعليق",
    "Submitfeedback": "إرسال التعليق",
    "Pleaseenteravalidemailaddress": "يرجى إدخال عنوان بريد إلكتروني صالح",
    "Pleaseenteryouremailaddress": "يرجى إدخال عنوان بريدك الإلكتروني",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "لقد قدمت تعليقًا بالفعل اليوم، يرجى العودة غدًا",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "تم إرسال التعليق بنجاح، شكرًا لتعليقك القيم",
    "Feedback_submission_failed_please_retry": "فشل إرسال التعليق، يرجى المحاولة مرة أخرى",
    "ContactUs": "اتصل بنا",
    "XRPAddress": "يرجى ملء عنوان محفظة سلسلة XRP المفعلة (بما في ذلك MEMO)، وإلا فلن تتمكن من سحب النقود.",
    "Accelerated": "مُعجَّل",
    "Accelerated_withdrawals_success": "تم سحب المبالغ المُعجَّلة بنجاح",
    "login": "تسجيل الدخول",
    "register": "إنشاء حساب",
    "login_with_google": "تسجيل الدخول باستخدام Google",
    "or": "أو",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "no_account": "ليس لديك حساب",
    "click_to_go": "اضغط لـ",
    "have_account": "لديك حساب بالفعل",
    "go_to": "اذهب إلى",
    "invite_code": "رمز الدعوة",
    "optional": "اختياري",
    "google_login_not_ready": "تسجيل الدخول باستخدام Google غير جاهز، يرجى المحاولة مرة أخرى لاحقًا",
    "password_too_long": "كلمة المرور طويلة جدًا",
    "weak": "ضعيف",
    "medium": "متوسط",
    "strong": "قوي",
    "login_success": "تم تسجيل الدخول بنجاح",
    "login_failed": "فشل تسجيل الدخول",
    "please_input_email": "يرجى إدخال بريدك الإلكتروني",
    "invalid_email": "تنسيق البريد الإلكتروني غير صالح",
    "please_input_password": "يرجى إدخال كلمة المرور الخاصة بك",
    "password_length_6_to_16": "يجب أن تكون كلمة المرور من 6 إلى 16 حرفًا",
    "account_or_password_error": "خطأ في الحساب أو كلمة المرور",
    "register_success": "تم التسجيل بنجاح",
    "register_failed": "فشل التسجيل",
    "save_error": "خطأ في الحفظ، يرجى المحاولة مرة أخرى لاحقاً",
    "ShareToFriends": "شارك مع الأصدقاء",
    "login_first": "يرجى تسجيل الدخول أولاً",
    "WalletBscError": "❌ عنوان محفظة BNB Chain غير صالح.",
    "DownloadWallet": "قم بتنزيل المحفظة",
    "AddToHomeScreen": "أضف {appName} إلى الشاشة الرئيسية",
    "TapShareInToolbar": "اضغط على شريط الأدوات",
    "SelectAddToHomeScreen": "اختر إضافة إلى الشاشة الرئيسية",
    "OpenToolbar": "فتح شريط الأدوات",
    "ClaimFailed": "فشل في جمع المكافأة، يرجى المحاولة مرة أخرى لاحقاً",
    "guest_login": "تسجيل دخول الضيف",
    "please_input_phone": "يرجى إدخال رقم هاتفك",
    "email_error_1": "يرجى إدخال بريدك الإلكتروني",
    "email_error_2": "يرجى إدخال عنوان بريد إلكتروني صالح",
    "email_error_3": "لا يُسمح ببريد الضيف الإلكتروني، يرجى استخدام بريد إلكتروني حقيقي",
    "phone": "الهاتف",
    "phone_error_1": "يرجى إدخال رقم هاتفك",
    "phone_error_2": "يرجى إدخال رقم هاتف صالح",
    "update_info": "تحديث المعلومات",
    "update_success": "تم التحديث بنجاح",
    "update_failed": "فشل التحديث، يرجى المحاولة لاحقاً",
    "cancel": "إلغاء",
    "guest_credentials_title": "معلومات الحساب",
    "guest_credentials_warning": "يرجى أخذ لقطة شاشة لحفظ حسابك وكلمتك السرية. إذا فقدت، لن يمكن استرداد أرباحك!",
    "i_have_saved": "لقد حفظت",
    "account": "الحساب",
    "view_credentials": "عرض بيانات الاعتماد",
    "miner_max_reached": "لقد وصلت إلى الحد الأقصى لعدد هذا المنقب"
}};